import React from "react";
import PublicLayout from "../layouts/PublicLayout";
import Login from "../components/pages/user/Login";
import ConfitmOtp from "../components/pages/user/ConfirmOtp";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

const PublicRouter = () => {
  
  return (
    <div>
      <Router>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/confirm-otp" element={<ConfitmOtp />} />

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
};

export default PublicRouter;
